module.exports = __webpack_public_path__ + "public/img/w1.9aad9bda.png";